import type { ReactNode } from 'react';

/** Page title + subtitle block used at the top of every auth / onboarding form (Heading/Page + Body/Medium). */
export function AuthHeading({ title, subtitle }: { title: string; subtitle?: ReactNode }) {
  return (
    <div className="flex flex-col gap-(--mbm-space-2)">
      <h1 className="text-heading-page text-text-strong">{title}</h1>
      {subtitle ? <p className="text-body-medium text-text-secondary">{subtitle}</p> : null}
    </div>
  );
}
